import styled from 'styled-components';
import { AiOutlineLoading3Quarters } from 'react-icons/ai'

export const WarnModalOverlay = styled.div`
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background: rgba(0, 0, 0, 0.5);
    display: flex;
    justify-content: center;
    z-index: 99;
    overflow: auto;
`;

export const ModalContainer = styled.div`
    background: white;
    padding: 20px;
    border-radius: 8px;
    max-width: 600px;
    width: 100%;
    height: auto;
    max-height: 400px;
    justify-content: center;
    align-items: center;
    display: flex;
    margin-top: 150px;
    flex-direction: column;
    box-shadow: 0 2px 10px rgba(0, 0, 0, 0.1);
`;


export const ModalCloseButton = styled.button`
  border-radius: 50px;
  background: #cc8f2d;
  white-space: nowrap;
  padding: 2px 8px;
  color: #000;
  font-size: 20px;
  outline: none;
  border: none;
  cursor: pointer;
  transition: all 0.2s ease-in-out;
  text-decoration: none;
  text-align: center;
  margin-top: 20px;

  &:hover {
    transition: all 0.2s ease-in-out;
    background: #000;
    color: #cc8f2d;
  }
`;


export const FormH1 = styled.h1`
  color: #cc8f2d;
  font-size: 20px;
  font-weight: bold;
  text-align: center;
  margin-left: 12px;
`;